package com.anjuros.website.templates.template9.modules

import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Res

enum class Template9AboutFeature(
    val icon: String,
    val title: ResKey,
    val description: ResKey
) {
    Feature1(
        icon = Template9Res.Icon.shield_white,
        title = ResKey.TEMPLATE9_INFO_TITLE1,
        description = ResKey.TEMPLATE9_INFO_DESC1
    ),
    Feature2(
        icon = Template9Res.Icon.heart_white,
        title = ResKey.TEMPLATE9_INFO_TITLE2,
        description = ResKey.TEMPLATE9_INFO_DESC2
    ),
    Feature3(
        icon = Template9Res.Icon.calendar_white,
        title = ResKey.TEMPLATE9_INFO_TITLE3,
        description = ResKey.TEMPLATE9_INFO_DESC3
    )
}
